import { gql } from "@apollo/client";

import { CALL_RECORD_BASIC } from "@/graphql-client/fragments";

export const GET_CALL_RECORDS = gql`
  query GetPageCallRecords(
    $accountId: Int!
    $includeFailed: Boolean = false
    $limit: Int!
    $offset: Int!
  ) {
    callHistory(
      accountId: $accountId
      includeFailed: $includeFailed
      limit: $limit
      offset: $offset
    ) {
      items {
        ...CallRecordBasic
        recordingDownloadUrl
        completionDetails {
          hbaIndex
          delivered
        }
      }
      totalCount
    }
  }
  ${CALL_RECORD_BASIC}
`;

export const GET_CALLS_STATS = gql`
  query GetCallsStats($accountId: Int!) {
    callsStatistics(accountId: $accountId) {
      currentWeek {
        count
        durationSecs
      }
      previousWeek {
        count
        durationSecs
      }
      previous4Weeks {
        count
        durationSecs
      }
      currentRound {
        count
        durationSecs
      }
      allTime {
        count
        durationSecs
      }
    }
  }
`;

export const UPDATE_CALL_RECORD = gql`
  mutation UpdateCallRecord($callSid: String!, $data: JSONObject!) {
    updateCallRecord(callSid: $callSid, data: $data) {
      sid
      hbacalldata
    }
  }
`;

export const UPDATE_SESSION_COUNT = gql`
  mutation UpdateSessionCount($callSid: String!, $data: Float!) {
    updateSessionCount(callSid: $callSid, data: $data) {
      sid
      sessionCount
    }
  }
`;

export const UPDATE_HEALTHIE_FORM = gql`
  mutation UpdateHealthieForm($callSid: String!, $data: JSONObject!) {
    updateHealthieForm(callSid: $callSid, data: $data)
  }
`;

export const GET_SINGLE_CALL_RECORD = gql`
  query GetSingleCallRecord($callSid: String!) {
    callRecord(callSid: $callSid) {
      hbacalldata
      sessionCount
      sid
      callDeliverySpeed
      durationInSeconds
      outcome
      type
      createdOn
      recordingDownloadUrl
      programRating
      fullProgramRatingResponse
      errorDetails
      hangupDetails
      playlist {
        id
        isActive
        startOn
        endOn
        title
        playlistVoiceMessages {
          voiceMessage {
            title
            templateLink
            feature
            cognitiveDomains
          }
        }
      }
      account {
        firstName
        lastName
        id
        timeZone
        Id_Ehr
      }
    }
  }
`;
